module.exports = __webpack_public_path__ + "assets/img/mtTitle-0876493d.png";